"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Icon = require("./js/Icon");

var _Icon2 = _interopRequireDefault(_Icon);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WrappedIcon = function WrappedIcon(props) {
  return _react2.default.createElement(
    _Icon2.default,
    props,
    _react2.default.createElement(
      "svg",
      { viewBox: "0 0 1152 1152" },
      _react2.default.createElement("path", { fill: "#E2D8FF", d: "M447.7 581.6h-53v348.3c16.1 8.1 35.7 15.2 53 21.1V581.6zm97.6-22.3v410.3c7.4.4 18.4 4.2 25.9 4.2 9.4 0 17.9-.1 27.1-.8V559.3h-53zm304.1 291.3c18.8-19.9 38.5-43.9 53-67.4V517.4h-53v333.2zM268.8 603.8l122.4-141.1L507.5 506l248-177.9 125 118.3 62.8-50.3-9.6-20.8-52.5 44.3-123.3-115.3L506 484.6l-117-45.4-130.3 147.4-81.6 19.2v18.8l91.7-20.8zm25.5 83.8h-53v102.8c14.7 22.5 34.3 43.5 53 62.5V687.6zm457.4-234.3h-53v495.8c17.3-6.2 36.9-13.6 53-22.1V453.3z" }),
      _react2.default.createElement("path", { fill: "#9F7FFF", d: "M0 576c0 318.1 257.9 576 576 576s576-257.9 576-576S894.1 0 576 0 0 257.9 0 576zm59.4 0C59.4 290.3 290.7 58.8 576 58.8s516.6 231.6 516.6 517.2-231.3 517.2-516.6 517.2S59.4 861.7 59.4 576z" })
    )
  );
};

WrappedIcon.displayName = 'AdobeAnalyticsColorDark';
exports.default = WrappedIcon;

